import { Dropdown } from './options/Dropdown';
import { MultipleChoice } from './options/MultipleChoice';
import { ShortResponse } from './options/ShortResponse';
import { TrueFalse } from './options/TrueFalse';
import type { HandleChoiceChange, HandleTrueFalseChange, PreferenceFieldsProps } from './PreferenceFields.types';

export function PreferenceFields({
  translations,
  preferences,
  isLive,
  onDropdownPreferenceChange,
  onShortResponsePreferenceChange,
  onSingleChoicePreferenceChange,
  onMultipleChoicePreferenceChange,
  onTrueFalsePreferenceChange,
  onSubscriptionPreferenceChange,
}: PreferenceFieldsProps) {
  const handleTrueFalseChange: HandleTrueFalseChange = (value, id, preference) => {
    const data = preference.attrs?.data;

    if (data?.type === 'publication') {
      onSubscriptionPreferenceChange(value, id);
    } else if (data?.type === 'custom_field' || data?.type === 'newsletter_list') {
      onTrueFalsePreferenceChange(value, id);
    }
  };

  const handleChoiceChange: HandleChoiceChange = ({
    value,
    preference,
    isSingleChoice,
    onSingleChoicePreferenceChange,
    onMultipleChoicePreferenceChange,
    preferenceId,
  }) => {
    const customFieldId = preference.attrs?.data?.custom_field_id;

    if (!customFieldId) return;

    if (isSingleChoice && typeof value === 'string') {
      onSingleChoicePreferenceChange(value, preferenceId);
    } else if (!isSingleChoice && Array.isArray(value)) {
      onMultipleChoicePreferenceChange(value, preferenceId);
    }
  };

  return (
    <div className="flex flex-col gap-4 mb-4">
      {preferences.map((preference) => {
        switch (preference.type) {
          case 'boolean':
            return (
              <TrueFalse
                key={preference.key}
                element={preference}
                preferenceId={preference.key}
                isLive={isLive}
                translations={translations}
                onChange={(value, id) => {
                  handleTrueFalseChange(value, id, preference);
                }}
              />
            );
          case 'text':
            return (
              <ShortResponse
                key={preference.key}
                element={preference}
                preferenceId={preference.key}
                onChange={(value, id) => onShortResponsePreferenceChange(value, id)}
              />
            );
          case 'dropdown':
            return (
              <Dropdown
                key={preference.key}
                element={preference}
                preferenceId={preference.key}
                onChange={(value, id) => onDropdownPreferenceChange(value, id)}
              />
            );
          case 'multiple-choice':
            return (
              <MultipleChoice
                key={preference.key}
                element={preference}
                isLive={isLive}
                preferenceId={preference.key}
                onChange={(value) => {
                  handleChoiceChange({
                    value,
                    preference,
                    isSingleChoice: false,
                    onSingleChoicePreferenceChange,
                    onMultipleChoicePreferenceChange,
                    preferenceId: preference.key,
                  });
                }}
              />
            );
          case 'single-choice':
            return (
              <MultipleChoice
                key={preference.key}
                element={preference}
                isLive={isLive}
                preferenceId={preference.key}
                onChange={(value) => {
                  handleChoiceChange({
                    value,
                    preference,
                    isSingleChoice: true,
                    onSingleChoicePreferenceChange,
                    onMultipleChoicePreferenceChange,
                    preferenceId: preference.key,
                  });
                }}
              />
            );
          default:
            return null;
        }
      })}
    </div>
  );
}
